<template>
  <div>
    <v-card>
      <v-list dense>
        <v-list-item v-if="dialogData.length==0">
          <v-list-item-content>No Data Available</v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list dense>
        <v-list-item v-for="(item, index) in dialogData" :key="index" @click.stop>
          <v-list-item-content>
            <v-list-item-title>{{index +1 }}.{{item.label}}.</v-list-item-title>
            <v-list-item-subtitle v-text="item.value"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ["dialogData"],
  created: function() {
    console.log(this.dialogData);
  },
  data() {
    return {
      text: "",
      timeout: 1700,
      serveyTittle: "",
      survey_type: "",
      mobileNumber: "",
      causeOfloss: "",
      claimname: "",
      refenceNumber: "",
      serveydescription: "",
      alertPositive: false,
      alertNegetive: false,

      surveyname: "",
      serveyorcrd: false,
      itemsAraayOfsurveyid: [],
      serveyorNotes: "",
      serviorName: ""
    };
  },
  methods: {}
};
</script>

